import { memo } from 'preact/compat'
import { useState, useEffect } from 'preact/hooks'
import badgesList from 'core/helpers/badges_list'
import { getStylesFn } from 'core/helpers/styles'
import { ElementBadgeOptions } from 'core/types/element/element_badge'
import optionsPropTypes from 'PropsSpec'

const exractStyles = getStylesFn(['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'], {
  transition: 'opacity 90ms',
  width: 'fit-content',
  margin: '0 auto'
})

const IMG_STYLES = {
  maxWidth: '100%'
}

const actions = {
  none: 'none',
  goToUrl: 'go_to_url',
  nextStep: 'next_step'
}

type Props = {
  options: ElementBadgeOptions
}

const Badge = (props: Props) => {
  const { options } = props
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    const intervalId = setTimeout(() => {
      setLoaded(true)
    }, 500)

    return () => clearTimeout(intervalId)
  }, [options.badge])

  const onImageLoad = () => {
    setLoaded(true)
  }

  const styles = {
    ...exractStyles(options),
    opacity: loaded ? 1 : 0,
    cursor: options.action === actions.goToUrl || options.action === actions.nextStep ? 'pointer' : 'default'
  }

  const onClick = () => {
    switch (options.action) {
      case actions.goToUrl:
        if (options.action_go_to_url) {
          window.open(options.action_go_to_url, '_blank')?.focus()
        }
        break
      case actions.none:
      default:
        break
    }
  }

  const badgeUrl = badgesList.find(b => b.id === options.badge)?.url

  return (
    <div style={styles} className="wf_reset wf_badge_wrapper">
      <img
        onClick={onClick}
        onLoad={onImageLoad}
        style={IMG_STYLES}
        className="wf_reset wf_badge"
        src={badgeUrl}
        width={options.image_width}
        height={options.image_height}
      />
    </div>
  )
}

Badge.propTypes = {
  options: optionsPropTypes('badge')
}

export default memo(Badge)
